module.exports = __webpack_public_path__ + "img/12.ac5e0012.jpg";